import Footer from "../../components/Footer"
import NavbarPrivate from "../../components/navbar/NavbarPrivate"
import NavbarPublic from "../../components/navbar/NavbarPublic"
import useAuth from "../../hooks/useAuth"

const Terms = () => {
  const { auth } = useAuth()
  return (
    <section className="h-screen flex flex-col">
      {auth ? <NavbarPrivate /> : <NavbarPublic />}
      <div className="mb-auto flex-1 overflow-y-auto">
        <div className="container mx-auto px-5 md:px-16">
          <section id="terms_conditions">
            <h1 className="text-3xl md:text-5xl font-extrabold dark:text-white mt-10">
              Terms and Conditions
            </h1>
            <p className="mb-4 text-lg font-normal text-gray-500 dark:text-neutral-300 mt-4">
              Welcome to HackTricks Training. The following terms and conditions
              (the "Agreement") outline the rules and regulations for the use of
              our website and the services offered. By using our website and
              enrolling in our courses, you agree to be bound by the terms and
              conditions outlined in this Agreement. If you do not agree to
              these terms and conditions, please do not use our website or
              enroll in our courses.
            </p>
            <ol className="nested space-y-5 list-inside mb-20">
              <li className="nested mb-4 text-2xl md:text-4xl font-bold dark:text-white">
                General Provisions
                <ol className="nested text-gray-500 list-decimal list-inside dark:text-neutral-300 mt-4">
                  <li className="nested mb-4 text-lg font-normal text-gray-500 dark:text-neutral-300">
                    This Agreement governs the relationship between our company
                    and you, the user, in relation to the use of our website and
                    the provision of our courses.
                  </li>
                  <li className="nested mb-4 text-lg font-normal text-gray-500 dark:text-neutral-300">
                    Our website and courses are designed for educational
                    purposes only and are not intended to provide legal or
                    professional advice.
                  </li>
                  <li className="nested mb-4 text-lg font-normal text-gray-500 dark:text-neutral-300">
                    We reserve the right to modify these terms and conditions at
                    any time, without prior notice. It is your responsibility to
                    review the terms and conditions regularly to ensure that you
                    are aware of any changes.
                  </li>
                </ol>
              </li>
              <li className="nested mb-4 text-2xl md:text-4xl font-bold dark:text-white">
                Registration and Payment
                <ol className="nested text-gray-500 list-decimal list-inside dark:text-neutral-300 mt-4">
                  <li className="nested mb-4 text-lg font-normal text-gray-500 dark:text-neutral-300">
                    To enroll in our courses, you must register on our website
                    and pay the applicable fees.
                  </li>
                  <li className="nested mb-4 text-lg font-normal text-gray-500 dark:text-neutral-300">
                    The fees for our courses are stated on our website and are
                    subject to change without prior notice.
                  </li>
                  <li className="nested mb-4 text-lg font-normal text-gray-500 dark:text-neutral-300">
                    Payment must be made in full at the time of enrollment.
                  </li>
                  <li className="nested mb-4 text-lg font-normal text-gray-500 dark:text-neutral-300">
                    Upon completion of the registration process and payment of
                    the applicable fees, you will receive access to the course
                    materials.
                  </li>
                </ol>
              </li>
              <li className="nested mb-4 text-2xl md:text-4xl font-bold dark:text-white">
                Course Materials
                <ol className="nested text-gray-500 list-decimal list-inside dark:text-neutral-300 mt-4">
                  <li className="nested mb-4 text-lg font-normal text-gray-500 dark:text-neutral-300">
                    The course materials provided are the property of our
                    company and are protected by copyright laws.
                  </li>
                  <li className="nested mb-4 text-lg font-normal text-gray-500 dark:text-neutral-300">
                    The course materials are intended for your personal,
                    non-commercial use only. You may not reproduce, distribute,
                    or display the course materials without our prior written
                    consent.
                  </li>
                  <li className="nested mb-4 text-lg font-normal text-gray-500 dark:text-neutral-300">
                    We reserve the right to modify the course materials at any
                    time, without prior notice.
                  </li>
                </ol>
              </li>
              <li className="nested mb-4 text-2xl md:text-4xl font-bold dark:text-white">
                Exam
                <ol className="nested text-gray-500 list-decimal list-inside dark:text-neutral-300 mt-4">
                  <li className="nested text-xl md:text-2xl  font-bold dark:text-white">
                    Exam Rules
                    <ol className="nested text-gray-500 list-decimal list-inside dark:text-neutral-300 mt-4">
                      <li className="nested mb-4 text-lg font-normal text-gray-500 dark:text-neutral-300">
                        You must complete the Exam within the specified time
                        limit.
                      </li>
                      <li className="nested mb-4 text-lg font-normal text-gray-500 dark:text-neutral-300">
                        You are not allowed to ask for help from anyone during
                        the Exam.
                      </li>
                      <li className="nested mb-4 text-lg font-normal text-gray-500 dark:text-neutral-300">
                        You are not allowed to share your Exam questions or
                        answers with anyone.
                      </li>
                      <li className="nested mb-4 text-lg font-normal text-gray-500 dark:text-neutral-300">
                        You are not allowed to reproduce, distribute, or display
                        Exam content in any form without prior written consent
                        from the Exam administrator.
                      </li>
                    </ol>
                  </li>
                  <li className="nested text-xl md:text-2xl  font-bold dark:text-white">
                    Prohibited Conduct
                    <ol className="nested text-gray-500 list-decimal list-inside dark:text-neutral-300 mt-4">
                      <li className="nested mb-4 text-lg font-normal text-gray-500 dark:text-neutral-300">
                        You are not allowed to engage in any behavior that would
                        compromise the integrity of the Exam, including but not
                        limited to cheating, copying, or distributing Exam
                        materials.
                      </li>
                      <li className="nested mb-4 text-lg font-normal text-gray-500 dark:text-neutral-300">
                        You are not allowed to attempt to access Exam materials
                        or information that you are not authorized to access.
                      </li>
                      <li className="nested mb-4 text-lg font-normal text-gray-500 dark:text-neutral-300">
                        You are not allowed to disrupt or interfere with the
                        Exam, or with the ability of others to take the Exam.
                      </li>
                      <li className="nested mb-4 text-lg font-normal text-gray-500 dark:text-neutral-300">
                        You are not allowed to impersonate another person during
                        the Exam.
                      </li>
                    </ol>
                  </li>
                  <li className="nested text-xl md:text-2xl  font-bold dark:text-white">
                    Exam Security
                    <ol className="nested text-gray-500 list-decimal list-inside dark:text-neutral-300 mt-4">
                      <li className="nested mb-4 text-lg font-normal text-gray-500 dark:text-neutral-300">
                        The Exam administrator will take measures to ensure the
                        security of the Exam content and prevent unauthorized
                        access to Exam materials.
                      </li>
                    </ol>
                  </li>
                  <li className="nested text-xl md:text-2xl  font-bold dark:text-white">
                    Exam Results
                    <ol className="nested text-gray-500 list-decimal list-inside dark:text-neutral-300 mt-4">
                      <li className="nested mb-4 text-lg font-normal text-gray-500 dark:text-neutral-300">
                        Exam results will be determined solely by the Exam
                        administrator.
                      </li>
                      <li className="nested mb-4 text-lg font-normal text-gray-500 dark:text-neutral-300">
                        You will receive your Exam results within 30 business
                        days of completing the Exam, via email.
                      </li>
                    </ol>
                  </li>
                  <li className="nested text-xl md:text-2xl  font-bold dark:text-white">
                    Disclaimer of Warranties
                    <ol className="nested text-gray-500 list-decimal list-inside dark:text-neutral-300 mt-4">
                      <li className="nested mb-4 text-lg font-normal text-gray-500 dark:text-neutral-300">
                        The Exam is provided "as is" without warranty of any
                        kind, whether express or implied. Failure to comply with
                        the above points could lead to the withdrawal of
                        certification and access to the platform.
                      </li>
                    </ol>
                  </li>
                </ol>
              </li>
              <li className="nested mb-4 text-2xl md:text-4xl font-bold dark:text-white">
                Privacy Policy
                <ol className="nested text-gray-500 list-decimal list-inside dark:text-neutral-300 mt-4">
                  <li className="nested mb-4 text-lg font-normal text-gray-500 dark:text-neutral-300">
                    Our privacy policy outlines how we collect, use, and protect
                    your personal information. By using our website and
                    enrolling in our courses, you agree to be bound by our
                    privacy policy.
                  </li>
                  <li className="nested mb-4 text-lg font-normal text-gray-500 dark:text-neutral-300">
                    We will not disclose your personal information to third
                    parties, except as required by law.
                  </li>
                </ol>
              </li>
              <li className="nested mb-4 text-2xl md:text-4xl font-bold dark:text-white">
                Limitation of Liability
                <ol className="nested text-gray-500 list-decimal list-inside dark:text-neutral-300 mt-4">
                  <li className="nested mb-4 text-lg font-normal text-gray-500 dark:text-neutral-300">
                    Our company shall not be liable for any damages arising out
                    of or in connection with the use of our website or the
                    provision of our courses.
                  </li>
                  <li className="nested mb-4 text-lg font-normal text-gray-500 dark:text-neutral-300">
                    We shall not be liable for any indirect, incidental, or
                    consequential damages, including without limitation, loss of
                    profits or revenue, loss of data, or business interruption.
                  </li>
                </ol>
              </li>
              <li className="nested mb-4 text-2xl md:text-4xl font-bold dark:text-white">
                Governing Law and Jurisdiction
                <ol className="nested text-gray-500 list-decimal list-inside dark:text-neutral-300 mt-4">
                  <li className="nested mb-4 text-lg font-normal text-gray-500 dark:text-neutral-300">
                    This Agreement shall be governed by the laws of the Kingdom
                    of Spain.
                  </li>
                  <li className="nested mb-4 text-lg font-normal text-gray-500 dark:text-neutral-300">
                    Any disputes arising out of or in connection with this
                    Agreement shall be subject to the exclusive jurisdiction of
                    the courts of the Kingdom of Spain.
                  </li>
                </ol>
              </li>
              <li className="nested mb-4 text-2xl md:text-4xl font-bold dark:text-white">
                Termination
                <ol className="nested text-gray-500 list-decimal list-inside dark:text-neutral-300 mt-4">
                  <li className="nested mb-4 text-lg font-normal text-gray-500 dark:text-neutral-300">
                    We reserve the right to terminate this Agreement and your
                    access to our website and courses at any time, without prior
                    notice, for justified reasons.
                  </li>
                  <li className="nested mb-4 text-lg font-normal text-gray-500 dark:text-neutral-300">
                    Upon termination, you must immediately cease all use of our
                    website and courses.
                  </li>
                </ol>
              </li>
              <li className="nested mb-4 text-2xl md:text-4xl font-bold dark:text-white">
                Entire Agreement
                <ol className="nested text-gray-500 list-decimal list-inside dark:text-neutral-300 mt-4">
                  <li className="nested mb-4 text-lg font-normal text-gray-500 dark:text-neutral-300">
                    This Agreement constitutes the entire agreement between our
                    company and you in relation to the use of our website and
                    the provision of our courses.
                  </li>
                  <li className="nested mb-4 text-lg font-normal text-gray-500 dark:text-neutral-300">
                    ny other terms or conditions that are inconsistent with this
                    Agreement are hereby excluded. If you have any questions or
                    concerns about these terms and conditions, please contact us
                    at support@hacktricks.xyz
                  </li>
                </ol>
              </li>
            </ol>
          </section>
        </div>
        <Footer />
      </div>
    </section>
  )
}

export default Terms
